import { render, staticRenderFns } from "./patientManagement.vue?vue&type=template&id=8ddbedd8&scoped=true&"
import script from "./patientManagement.vue?vue&type=script&lang=js&"
export * from "./patientManagement.vue?vue&type=script&lang=js&"
import style0 from "./patientManagement.vue?vue&type=style&index=0&id=8ddbedd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddbedd8",
  null
  
)

export default component.exports